import { createAsyncThunk } from '@reduxjs/toolkit';

import { QUERY_PARAMS } from 'constants/queryNames';

import { sendSentryClientErrorOnce } from 'shared/lib/sendSentryClientError';
import type { TOffer } from 'shared/types/TRankingService';

import { getStAffAndOfferFromUrl, getStParentId } from '../../lib';
import { stTrackingApi } from '../stTracking.query';

export const resolveStOrderIdThunk = createAsyncThunk<string | null, TOffer>(
  'offerControls/resolveStOrderIdThunk',
  async (offer, { dispatch }) => {
    try {
      const stParentId = getStParentId();
      const stAffAndOffer = getStAffAndOfferFromUrl(
        offer.additionalInfo?.displayPixelUrl,
        QUERY_PARAMS.PARTNER_OFFER_ID,
      );

      if (!stParentId || !stAffAndOffer) {
        return null;
      }

      const response = await dispatch(
        stTrackingApi.endpoints.stTrackingClick.initiate({
          affId: stAffAndOffer.affId,
          offerId: stAffAndOffer.offerId,
          rootTransactionId: stParentId,
        }),
      ).unwrap();

      return response?.transaction_id ?? null;
    } catch (error) {
      sendSentryClientErrorOnce('resolveStOrderIdThunk', error);
      return null;
    }
  },
);
